import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReadyForTakeoff() {
  return <section data-section-id="232881" id="ready-for-takeoff" className="dark bg-primary text-primary-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_60%)] opacity-[0.15]" />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.2] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
      backgroundSize: "200px 200px"
    }} />

      <div className="container relative z-10 mx-auto px-4 text-center md:px-6">
        <div className="mx-auto max-w-3xl space-y-10">
          <h2 className="font-default text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl lg:text-7xl uppercase text-primary-foreground">
            READY TO WRITE YOUR STORY?
          </h2>
          
          <div className="flex justify-center">
            <Button asChild size="lg" className="h-16 rounded-lg px-10 text-lg font-default font-bold bg-secondary text-secondary-foreground shadow-xl shadow-black/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:bg-secondary/90">
              <Link to="/ExpeditionsPage">
                <MessageCircle className="mr-3 size-6" />
                Start Custom Planning
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}